import { updateKeyInStore } from 'App';
import * as Yup from 'yup';
import { store } from 'app/redux/store';

import {
  SpecialDeductionsInformationStateValues,
  updateKey,
  updateFieldArrayKey,
} from './slice';

export const fields: IBaseField<
  keyof SpecialDeductionsInformationStateValues
>[] = [
  {
    name: 'didYouExperienceALossOfMoreThan10OfYourIncomeDueToCasualtyOrTheft',
    label:
      'Did you experience a loss of more than 10% of your income due to casualty or theft?',
    type: 'radio',
    effect: updateKeyInStore(updateKey),
    tooltip: '',
    comment: true,
  },
  {
    name: 'areYouTakingDeductionsForTravelMealsWithClientsOrEntertainingClients',
    label:
      'Are you taking deductions for travel, meals with clients or entertaining clients?',
    type: 'radio',
    effect: updateKeyInStore(updateKey),
    tooltip: '',
    comment: true,
    dependencies: [
      {
        name: 'didYouKeepReceiptsForAllRelatedExpenditures',
        label: 'Did you keep receipts for all related expenditures?',
        type: 'radio',
        effect: updateKeyInStore(updateKey),
        predicate: (v) => v === 'yes',
        comment: true,
      },
    ],
  },
  {
    name: 'didYouMakeCashDonationsForMoreThan250AtAnyOneTimeThisYear',
    label:
      'Did you make cash donations for more than $250 at any one time this year?',
    type: 'radio',
    effect: updateKeyInStore(updateKey),
    tooltip: '',
    comment: true,
    dependencies: [
      {
        name: 'didYouReceiveAcknowledgmentLettersForTheDonations',
        label: 'Did you receive acknowledgment letters for the donations?',
        type: 'radio',
        effect: updateKeyInStore(updateKey),
        predicate: (v) => v === 'yes',
        comment: true,
      },
    ],
  },

  {
    name: 'didYouDonatePhysicalGoodsThisYear',
    label: 'Did you donate physical goods this year?',
    type: 'radio',
    effect: updateKeyInStore(updateKey),
    tooltip: '',
    comment: true,
    dependencies: [
      {
        name: 'didYouKeepRecordsOfTheDonationsAndTheirValue',
        label: 'Did you keep records of the donations and their value?',
        type: 'radio',
        effect: updateKeyInStore(updateKey),
        predicate: (v) => v === 'yes',
        comment: true,
      },
    ],
  },

  {
    name: 'canYouSupportYourDeductionsIfYouAreAudited',
    label: 'Can you support your deductions if you are audited?',
    type: 'radio',
    effect: updateKeyInStore(updateKey),
    tooltip: '',
    comment: true,
  },
];

export const validationSchema = Yup.object().shape({});
